import { render, staticRenderFns } from "./HeatmapModule.vue?vue&type=template&id=4c8badc2&scoped=true"
import script from "./HeatmapModule.vue?vue&type=script&lang=js"
export * from "./HeatmapModule.vue?vue&type=script&lang=js"
import style0 from "./HeatmapModule.vue?vue&type=style&index=0&id=4c8badc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8badc2",
  null
  
)

export default component.exports